import { fetchIPERC } from "../http-common";

const postListarActividadesLineaBase = (filter: {
  procesoLineaBaseId: string;
}) => {
  return fetchIPERC.post(
    `ActividadLineaBase/ListarActividadesPorProceso`,
    filter
  );
};

const ActividadLineaBaseService = {
  postListarActividadesLineaBase,
};

export default ActividadLineaBaseService;
